<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <!-- <div class="col-sm-6">
            <h1>TICKET HISTORY</h1>
          </div> -->
          <div class="col-sm-6">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'dashboard' }">Dashboard</router-link>
              </li>
              <li class="breadcrumb-item active">Support Ticket</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <!-- Main content -->
    <section class="content" v-if="has_permission === true">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-8">
            <div class="card">
              <div class="card-header">
                <!-- <a href="javascript:void(0)" class="btn btn-info" @click="showFilter = !showFilter"><i
                    class="fa fa-filter"></i>Filter</a> -->
                <h3 class="card-title">Ticket History</h3>
                <div class="card-tools">
                  <!-- <button class="btn btn-info" @click="exportFile()">
                      <i class="fas fa-download"></i> Export
                    </button> -->
                </div>
              </div>

              <div class="overlay" v-if="list.is_loading">
                <i class="fas fa-2x fa-sync-alt fa-spin"></i>
              </div>
              <div class="col-md-12 card-body pt-0 pb-2">
                <div class="ticket-card">
                  <ul>
                    <router-link
                      v-for="(item, index) in list.data"
                      :key="item.id"
                      class="ticket-card-list"
                      tag="li"
                      :to="{
                        name: 'ticket-details',
                        params: { id: item.id },
                      }"
                    >
                      <p class="ticket-card-date">{{ item.lastUpdate }}</p>
                      <h4 class="ticket-card-sub">{{ item.subject }}</h4>
                      <div class="ticket-card-id">
                        Ticket ID: #{{ item.id }}
                        <span class="badge" :class="item.className">{{
                          item.status
                        }}</span>
                      </div>
                    </router-link>
                  </ul>
                </div>

                <div
                  class="p-4"
                  v-if="_.isEmpty(list.data) && !list.is_loading"
                >
                  <div class="alert alert-default-warning" role="alert">
                    No data found!
                  </div>
                </div>

                <div class="card-footer">
                  <vue-pagination
                    :pagination="list"
                    v-if="list.total > list.per_page"
                    @paginate="getTicketList()"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="card ticket-intro">
              <div class="card-header">
                <h3 class="card-title">Open new ticket</h3>
              </div>
              <div class="card-body">
                <p>
                  This private ticketing system is developed to handle queries
                  &amp; complain of our direct customers.
                </p>
                <div class="d-flex justify-content-between">
                  <router-link
                    :to="{ name: 'open-ticket' }"
                    class="btn btn-dark-blue"
                  >
                    Open New Ticket
                  </router-link>
                  <a
                    class="btn btn-help"
                    href="https://help.carnivalinternet.co.uk/"
                    target="_blank"
                    >Get help</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="content" v-if="has_permission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section>
  </div>
</template>
<style scoped>
.badge.closed {
  background: #ddfbe4 !important;
  color: #16a085 !important;
}
.badge.pending {
  background: #ffe9dd !important;
  color: #e74c3c !important;
}
.badge.open {
  background: #f3e5ff !important;
  color: #8e44ad !important;
}
.badge.in-progress {
  background: #ffe9dd !important;
  color: #e67e22 !important;
}
</style>
<script>
import { SwipeList, SwipeOut } from "vue-swipe-actions";
import VuePagination from "@/components/partials/PaginationComponent";
import SortIcons from "@/components/utils/SortIcons";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue-swipe-actions/dist/vue-swipe-actions.css";
import { CommonAPI } from "@/services/api";
const fileDownload = require("js-file-download");
import { Notification } from "element-ui";

export default {
  name: "TicketHistory",
  metaInfo: {
    title: "Ticket History | Dotlines",
  },
  components: {
    DatePicker,
    VuePagination,
    SortIcons,
    SwipeOut,
    SwipeList,
  },

  data: () => ({
    list: {
      is_loading: true,
      data: [],
      total: 0,
      per_page: 3,
      from: 1,
      to: 0,
    },
    order_by: "asc",
    api_url: "",
    showFilter: false,
    filter: {},
    dateRange: "",
    pre: [],
    is_loading: false,
    has_permission: true,
  }),
  // method is called after page load
  mounted: function () {
    if (this.isMobile()) {
      var openOrClose = window.$(document).find(".sidebar-mini");
      if ($(openOrClose).hasClass("sidebar-open")) {
        window.$(document).find(".push-menu-class").trigger("click");
      }

      // window.$(document).find('.push-menu-class').trigger('click');
    }

    this.api_url = "/ticketList";
    this.getTicketList();
    // this.getOrganization();
    this.$root.$on("sort-data", () => {
      this.$root.$emit("show-icon");
      this.getTicketList();
    });
  },

  methods: {
    itemClick() {},

    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD hh:mm:ss");
    },

    getTicketList() {
      this.list.is_loading = true;
      let query = { ...this.filter, ...this.$route.query };

      this.list.data = [
        // {
        //   subject: "#92762990 Get A Call Back", lastUpdate: '12/02/2022', status: 'Open'
        // },
      ];

      let subscriber = localStorage.getItem("subscriber");
      subscriber = JSON.parse(subscriber);

      if (subscriber) {
        query.cuid = subscriber.username;
        axios({
          method: "get",
          url: "/get-ticket",
          headers: { "Content-Type": "application/json" },
          params: query,
        })
          .then((response) => {
            //console.log("Res::", response)
            console.log("Response Data::", response);
            response.data.data.length > 0
              ? response.data.data.map((o) => {
                  o.lastUpdate = moment(o.updated_at).format("DD MMM YYYY");
                  o.subject = o.title;
                  // o.class =
                  //   o.ticket_state && o.ticket_state.states == "Open"
                  //     ? "pending"
                  //     : "closed";
                  let state =
                    o.ticket_state && o.ticket_state.states
                      ? o.ticket_state.states
                      : "";
                  let state_names = state.split(/[ ,]+/);
                  let className =
                    state_names.length > 0 ? state_names.join("-").toLowerCase() : "";
                  o.className = className;

                  o.status =
                    o.ticket_state && o.ticket_state.states
                      ? o.ticket_state.states
                      : "NA";
                  return o;
                })
              : [];
            //  console.log("data::", data)
            response.data.data.length > 0
              ? response.data.data.sort((a, b) => {
                  return moment(b.updated_at) - moment(a.updated_at);
                })
              : [];

            this.list = response.data;
            this.list.is_loading = false;
          })
          .catch((error) => {
            this.list.is_loading = false;
          });
      }
    },

    apiUsage(query = null) {},

    resetFilter() {
      const query = Object.assign({}, this.$route.query);
      if (Object.keys(query).length > 0) {
        delete query.order_by;
        delete query.order_key;
        delete query.page;
        // Object.keys(query).forEach((key) => delete query.key);
        this.$router.replace({ query });
      }
      this.filter = {};
      this.getTicketList();
    },
  },
};
</script>
